"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL_PADDING = exports.TEXT_COLOR = exports.MessageBannerTypeIcons = exports.MessageBannerTypeColors = exports.MessageBannerIconColors = exports.MessageBannerDefaultProps = exports.MessageBannerDefaultAltTexts = exports.MessageBannerBorderColors = exports.MINIMUM_DISMISS_TIMEOUT = exports.ICON_WRAPPER_HEIGHT = exports.BANNER_PADDING = exports.BANNER_BORDER_WIDTH = exports.BANNER_BAR_WIDTH = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _iconAlertCircleFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-alert-circle-fill-extra-small"));
var _iconAlertTriangleFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-alert-triangle-fill-extra-small"));
var _iconCheckCircleFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-check-circle-fill-extra-small"));
var _iconInformationFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-information-fill-extra-small"));
var _iconQuestionCircleFillExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-question-circle-fill-extra-small"));
var _interfaces = require("./interfaces");
const TEXT_COLOR = exports.TEXT_COLOR = (0, _utils.token)('color.text.primary');
const BANNER_PADDING = exports.BANNER_PADDING = 16;
const BANNER_BAR_WIDTH = exports.BANNER_BAR_WIDTH = 8;
const BANNER_BORDER_WIDTH = exports.BANNER_BORDER_WIDTH = 2;
const VERTICAL_PADDING = exports.VERTICAL_PADDING = 12;
const ICON_WRAPPER_HEIGHT = exports.ICON_WRAPPER_HEIGHT = 24;
const MessageBannerTypeColors = exports.MessageBannerTypeColors = {
  [_interfaces.MessageBannerType.Informational]: (0, _utils.token)('color.status.info-bg'),
  [_interfaces.MessageBannerType.Warning]: (0, _utils.token)('color.status.warning-bg'),
  [_interfaces.MessageBannerType.Error]: (0, _utils.token)('color.status.critical-bg'),
  [_interfaces.MessageBannerType.Success]: (0, _utils.token)('color.status.success-bg'),
  [_interfaces.MessageBannerType.Bias]: (0, _utils.token)('color.status.bias-bg')
};
const MessageBannerBorderColors = exports.MessageBannerBorderColors = {
  [_interfaces.MessageBannerType.Informational]: (0, _utils.token)('color.status.info-fill'),
  [_interfaces.MessageBannerType.Warning]: (0, _utils.token)('color.status.warning-fill'),
  [_interfaces.MessageBannerType.Error]: (0, _utils.token)('color.status.critical-fill'),
  [_interfaces.MessageBannerType.Success]: (0, _utils.token)('color.status.success-fill'),
  [_interfaces.MessageBannerType.Bias]: (0, _utils.token)('color.status.bias-fill')
};
const MessageBannerIconColors = exports.MessageBannerIconColors = {
  [_interfaces.MessageBannerType.Informational]: (0, _utils.token)('color.status.info-icon'),
  [_interfaces.MessageBannerType.Warning]: (0, _utils.token)('color.status.warning-icon'),
  [_interfaces.MessageBannerType.Error]: (0, _utils.token)('color.status.critical-icon'),
  [_interfaces.MessageBannerType.Success]: (0, _utils.token)('color.status.success-icon'),
  [_interfaces.MessageBannerType.Bias]: (0, _utils.token)('color.status.bias-icon')
};
const MessageBannerTypeIcons = exports.MessageBannerTypeIcons = {
  [_interfaces.MessageBannerType.Informational]: _iconInformationFillExtraSmall.default,
  [_interfaces.MessageBannerType.Warning]: _iconAlertTriangleFillExtraSmall.default,
  [_interfaces.MessageBannerType.Error]: _iconAlertCircleFillExtraSmall.default,
  [_interfaces.MessageBannerType.Success]: _iconCheckCircleFillExtraSmall.default,
  [_interfaces.MessageBannerType.Bias]: _iconQuestionCircleFillExtraSmall.default
};
const MessageBannerDefaultAltTexts = exports.MessageBannerDefaultAltTexts = {
  [_interfaces.MessageBannerType.Informational]: 'Information',
  [_interfaces.MessageBannerType.Warning]: 'Warning',
  [_interfaces.MessageBannerType.Error]: 'Error',
  [_interfaces.MessageBannerType.Success]: 'Success!',
  [_interfaces.MessageBannerType.Bias]: 'Attention'
};
const MessageBannerDefaultProps = exports.MessageBannerDefaultProps = {
  dismissButtonAltText: 'Dismiss',
  type: _interfaces.MessageBannerType.Informational,
  hasRoundedCorners: true
};
const MINIMUM_DISMISS_TIMEOUT = exports.MINIMUM_DISMISS_TIMEOUT = 20000;